import React from "react";
import GlassAnimalsImg from '../ArtistImages/GlassAnimals.jpeg';
import './ArtistPages.css'
import HeatWaves from '../CoverImages/HeatWaves.jpeg';
import { Link } from 'react-router-dom';

const GlassAnimals = () =>{
    return(
        <div className="ArtistPagesContainer">
            <div className="header">
                <img src={GlassAnimalsImg} height={'250px'} className="ArtistImage"/>
                <h2 className="ArtistName">Glass Animals</h2>
            </div>
            <ul>
                <br/><br/><br/>
                <Link to='/heatwaves'>
                    <li className='Songs'>
                        <img src={HeatWaves} height={200}/>
                        <div className='Text'>
                            <h2>Heat Waves</h2>
                            <p>Charts Topper 2022</p>
                        </div>
                    </li>
                </Link>
                <br/>
            </ul>
        </div>
    )

}

export default GlassAnimals;